import React, { useEffect } from 'react';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import AboutUs from './components/AboutUs';
import Clients from './components/Clients';
import Service from './components/Service';
/*import EnquiryForm from './components/EnquiryForm';*/
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (

   
    <div className="App">
      <Header />
      <HeroBanner />

      <div id="about-us" style={{ scrollMarginTop: '80px' }}>
        <AboutUs />
      </div>

      <div id="services" style={{ scrollMarginTop: '80px' }}>
        <Service />
      </div>

      <div id="portfolio" style={{ scrollMarginTop: '80px' }}>
        <Portfolio />
      </div>
      
      
      { 
      <div id="testimonials" style={{ scrollMarginTop: '80px' }}>
        <Testimonials />
      </div>
      }
      
      {/* <div id="contact" style={{ scrollMarginTop: '80px' }}>
        <EnquiryForm />
      </div> */}

      {/* Optional sections not linked in navbar */}
      <Clients />
      <Footer />
    </div>
  );
}

export default App;
